import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { PreviewNumberModalComponent } from '../preview-number-modal/preview-number-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-caller-number-modal',
  templateUrl: './caller-number-modal.component.html',
  styleUrls: ['./caller-number-modal.component.scss']
})
export class CallerNumberModalComponent implements OnInit {

  action = 'exit'
  form: FormGroup

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public clipBoardService: ClipBoardService,
    private snackBar: MatSnackBar,
    private serverService: ServerService,
    private dialogRef: MatDialogRef<PreviewNumberModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.form = this.fb.group({
      contactNumber: [parseInt(data.phone), Validators.required]
    })
  }

  ngOnInit() { }

  addCallerId() {
    this.dialogRef.close();
    this.router.navigate(['/call-setting-page/call-setting-dashboard']);    
  }

  close() {
    this.dialogRef.close();
  }

}
